import styled from 'styled-components';

export const LabelText = styled.p`
  font-weight: bold;
  padding-top: 4px;
  padding-right: 24px;
  text-align: right;
  width: 100%;
`;

export const ValueText = styled.p`
  padding-top: 4px;
  width: 100%;
`;

export const SuccessText = styled.p`
  font-weight: bold;
  margin-bottom: 25px;
  width: 447px;
`;

type ErrorTextProps = {
  fontWeight?: string;
  mb?: number;
};

export const ErrorText = styled.p<ErrorTextProps>`
  color: ${({ theme }) => theme.red};
  font-weight: ${({ fontWeight }) => fontWeight ?? 'normal'};
  margin-bottom: ${({ mb }) => mb ?? '25'}px;
  width: 447px;
`;

export const RequiredIndicator = styled.span`
  color: ${({ theme }) => theme.red};
  font-family: SimSun, sans-serif;
  font-size: 14px;
  font-weight: normal;
`;

export const ValidationToolbar = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const ValidationSummary = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;
`;

export const ValidationPaginationHelpText = styled.span`
  color: ${({ theme }) => theme.secondaryTextColor};
  white-space: nowrap;
`;

export const ValidationTableContainer = styled.div`
  .ant-table-cell.csv-damage-invalid-cell {
    background-color: color-mix(in srgb, ${({ theme }) => theme.red} 8%, transparent);
  }

  .ant-table-pagination.ant-pagination {
    align-items: center;
    justify-content: flex-end;
  }

  .ant-pagination-total-text {
    margin-inline-end: auto;
  }
`;

export const ValidationErrorPopoverContent = styled.ul`
  color: ${({ theme }) => theme.red};
  margin: 0;
  max-width: 280px;
  padding-left: 16px;
`;
